import { render, staticRenderFns } from "./NoticeList.vue?vue&type=template&id=3cbab314&scoped=true"
import script from "./NoticeList.vue?vue&type=script&lang=js"
export * from "./NoticeList.vue?vue&type=script&lang=js"
import style0 from "./NoticeList.vue?vue&type=style&index=0&id=3cbab314&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbab314",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cbab314')) {
      api.createRecord('3cbab314', component.options)
    } else {
      api.reload('3cbab314', component.options)
    }
    module.hot.accept("./NoticeList.vue?vue&type=template&id=3cbab314&scoped=true", function () {
      api.rerender('3cbab314', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NoticeIcon/NoticeList.vue"
export default component.exports